// extracted by mini-css-extract-plugin
var _1 = "CalendarGridWeekColumn-moduleCalendarGridWeekColumn__pmHFc";
var _2 = "CalendarGridWeekColumn-moduletoday__l69jr";
export { _1 as "CalendarGridWeekColumn", _2 as "today" }
